export default __webpack_public_path__ + "static/media/jap-ecommerceImg_3.9a2cbc83.png";